import { Ruler, Factory, ShieldCheck, Hammer } from 'lucide-react';
import CategoryTemplate from '../components/CategoryTemplate';
import { getRelated } from '../data/serviceCatalog';

const CustomMetal = () => {
  const trustPoints = [
    { Icon: Ruler, label: '現場条件に合わせた設計' },
    { Icon: Factory, label: '看板・カメラ・LEDの架台対応' },
    { Icon: ShieldCheck, label: '建設業許可(鋼構造物)' },
    { Icon: Hammer, label: '小ロット・特注 1点から' },
  ];

  const types = [
    { title: '看板・サイン用架台', desc: '壁面看板・自立看板・箱文字用の取付ブラケット・支柱。' },
    { title: 'カメラ・LED取付架台', desc: '防犯カメラ・LEDビジョン・電光掲示板の取付金物。' },
    { title: '特注ブラケット', desc: '既存構造物への取付に必要な特殊形状のブラケット。' },
    { title: '支柱・ポール類', desc: '照明・看板・カメラ・警報板の設置用の支柱・ポール。' },
    { title: '手すり・ステップ', desc: '施設・工場向けの安全のための金物類。' },
    { title: 'その他 鋼構造物工事', desc: '建設業許可のもとで対応可能な鋼構造物工事全般。' },
  ];

  const process = [
    { title: 'ヒアリング・現場確認', desc: '設置場所・対象製品・取付面・寸法・耐荷重などをお伺いします。' },
    { title: '設計・作図', desc: '現場条件に基づく製作図面を作成し、内容の合意を得ます。' },
    { title: '製作', desc: '自社ネットワークで切断・溶接・機械加工・表面処理を実施します。' },
    { title: '納品・施工', desc: '現場搬入と施工までを担当。既設との干渉調整もその場で対応。' },
  ];

  return (
    <CategoryTemplate
      id="custom-metal"
      eyebrow="CUSTOM METAL"
      name="カスタム金物製作"
      description="規格品では対応できない架台・ブラケット・取付金物を、現場条件に合わせて設計・製作します。建設業許可のもと、設計から施工まで一貫対応いたします。"
      tags={['取付金具', 'ブラケット', '特注金物', '現場対応', '鋼構造物工事']}
      heroImage="/images/services/custom-metal.png"
      trustPoints={trustPoints}
      types={types}
      processSteps={process}
      relatedServices={getRelated(['signage', 'led-vision', 'security-camera'])}
    />
  );
};

export default CustomMetal;
